import { Timezone } from '@/components/molecules/main-header/types';
import { create } from 'zustand';

interface OrganizationStore {
	organizationUuid: string;
	teamLeagueUuid: string;
	teamLeagueSlug: string;
	setOrganizationUuid: (organizationUuid: string) => void;
	setTeamLeagueUuid: (teamLeagueUuid: string) => void;
	setTeamLeagueSlugUuid: (teamLeagueUuid: string) => void;
	teamLeagueTimeZone: Timezone | null;
	setTeamLeagueTimeZone: (tlTimeZone: Timezone) => void;
}

export const useOrganizationStore = create<OrganizationStore>((set) => ({
	organizationUuid: '',
	teamLeagueUuid: '',
	teamLeagueSlug: '',
	setOrganizationUuid: (organizationUuid: string) => set(() => ({ organizationUuid: organizationUuid })),
	setTeamLeagueUuid: (teamLeagueUuid: string) => set(() => ({ teamLeagueUuid: teamLeagueUuid })),
	setTeamLeagueSlugUuid: (teamLeagueSlug: string) => set(() => ({ teamLeagueSlug: teamLeagueSlug })),
	teamLeagueTimeZone: null,
	setTeamLeagueTimeZone: (tlTimeZone: Timezone) => set(() => ({ teamLeagueTimeZone: tlTimeZone }))
}));
